var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuntrust = function SvgSuntrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "suntrust_svg__Calque_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".suntrust_svg__st1{fill:#002856}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "suntrust_svg__Calque_5"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 24.1c0 .6-.1 1.6-1.5 1.6-.3 0-.9 0-1.3-.3-.3-.3-.3-.7-.3-1.3V22c0-.2-.1-.3-.4-.3v-.3h1.9v.3c-.3 0-.4.1-.4.3v2.2c0 .5 0 1.1.8 1.1.9 0 .9-.7.9-1.2v-2.2c0-.2 0-.3-.3-.3h-.1v-.3h1.3v.3h-.2c-.3 0-.3.1-.3.3v2.2h-.1zM34.8 25.6h-2.1v-.3h.2c.3 0 .4-.1.4-.3v-3.2h-.4c-.2 0-.3.1-.3.2-.1.1-.1.4-.1.6h-.4v-1.1h3.4v1.1h-.3c0-.2 0-.5-.1-.6s-.2-.2-.3-.2h-.4V25c0 .2.1.3.4.3h.2l-.2.3zM32 24.5c-.1.7-.6 1.3-1.6 1.3-.6 0-1.2-.2-1.5-.3v-1h.3v.3s.1.2.2.3c.2.2.4.3.9.3.7 0 .9-.3.9-.7 0-.4-.3-.5-1.1-.8-.9-.2-1.3-.5-1.3-1.3 0-.7.5-1.3 1.5-1.3.6 0 .9.1 1.3.3v.9h-.3v-.3c0-.1-.1-.3-.2-.3-.3-.3-.6-.3-.9-.3s-.8.2-.8.6c0 .3.2.5.9.7.7.2.9.3 1.2.4.5.4.6.7.5 1.2M8.5 24.1c-.1.8-.7 1.5-2.2 1.5-.8 0-1.6-.3-1.9-.5v-1.3h.4v.4c0 .1.1.3.2.4.3.3.6.5 1.3.5.9 0 1.3-.5 1.3-1 0-.6-.4-.8-1.5-1-1-.3-1.7-.6-1.7-1.6 0-.9.7-1.7 2.1-1.7.9 0 1.3.2 1.6.3v1.2h-.3v-.4c0-.2-.2-.3-.3-.4-.3-.1-.7-.2-1.1-.1-.5 0-1 .3-1 .8s.2.7 1.2.9c.9.2 1.3.3 1.6.6.3.5.3.9.3 1.4M12.9 21.8c.3 0 .3.1.3.3v3.1c0 .2 0 .3-.3.3h-.1v.2h1.3v-.3H14c-.3 0-.3-.1-.3-.3v-2.6l1.7 3.1h.9v-3.5c0-.2 0-.3.3-.3h.3v-.5c0-.4 0-.9.6-.9h.6v4.4c0 .3-.1.5-.5.5h-.2v.3H20v-.3h-.2c-.4 0-.5-.1-.5-.5v-4.4h.6c.6 0 .6.4.6.9v.4h.4c.3 0 .3.1.3.3v3c0 .2-.2.3-.4.3v.3h1.9v-.3c-.3 0-.4-.1-.4-.3v-3.3h.5c.4 0 .7.2.7.8 0 .3-.2.8-.7.8h-.3s.8 1.5.9 1.8c.2.3.4.4.9.4h.8v-.3c-.1 0-.3 0-.4-.2l-.9-1.5c.5-.1.9-.5.9-1 0-1-1-1-1.6-1h-1.9V20h-4.5v1.5h-1v.3h.1c.3 0 .3.1.3.3v2.6l-1.7-3.1h-2.7v.3h.1c.3 0 .3.1.3.3v2.2c0 .5-.1 1.2-.9 1.2s-.8-.6-.8-1.1v-2.2c0-.2.1-.3.4-.3v-.3H8.7v.3c.3 0 .4.1.4.3v2.1c0 .6.1.9.3 1.2.3.3 1 .3 1.3.3 1.5 0 1.5-.9 1.5-1.8v-2.2c0 .1 0 0 .3 0l.4-.1z",
    className: "suntrust_svg__st1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_1_",
    x1: 8.091,
    x2: 15.99,
    y1: 3.116,
    y2: -6.298,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.4 14.6-.1.3c-.1.2-.1.6 0 .8l.4 2.3c0 .2.1.3.2.3s.1-.2 0-.5l-.3-3.1c-.1-.2-.2-.2-.2-.1",
    style: {
      fill: "url(#suntrust_svg__SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000116220707251298739840000008755612734568984990_",
    x1: 8.322,
    x2: 16.194,
    y1: 3.337,
    y2: -6.043,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000116220707251298739840000008755612734568984990_)"
    },
    d: "M9.3 17.1v.4c-.1 0-.1-.1-.2-.3L9 15.9c0-.2 0-.6.1-.8s.2-.1.2.1v1.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000098923137473893308830000013253144661817707420_",
    x1: 7.705,
    x2: 15.546,
    y1: 2.836,
    y2: -6.509,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000098923137473893308830000013253144661817707420_)"
    },
    d: "m9.9 12.4-.2 4c0 .2 0 .4-.1.4 0 0-.1-.1-.1-.3l-.1-3.4c0-.2.1-.4.2-.6l.1-.3c.1.1.2.1.2.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000174585984607408363510000010385169990037079999_",
    x1: 8.293,
    x2: 16.115,
    y1: 3.348,
    y2: -5.975,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000174585984607408363510000010385169990037079999_)"
    },
    d: "m10.5 13.3-.3 3.1c0 .3-.1.4-.1.4-.1 0-.1-.2-.1-.3l.1-2.7c.1-.2.3-.5.4-.5 0-.3 0-.2 0 0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000057130393045865138300000017669832276885484454_",
    x1: 7.953,
    x2: 15.759,
    y1: 3.077,
    y2: -6.225,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000057130393045865138300000017669832276885484454_)"
    },
    d: "M10.6 16.1c-.1 0-.1-.3 0-.3l.4-4.3c0-.2.2-.4.3-.5v-.1c.1-.2.2-.2.2 0l-.7 4.8c-.1.2-.1.4-.2.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000060009149835111213880000012981485412484032416_",
    x1: 8.492,
    x2: 16.277,
    y1: 3.54,
    y2: -5.738,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000060009149835111213880000012981485412484032416_)"
    },
    d: "M11.9 11.6c.1-.1.3-.1.3.1l-1 4.3c0 .2-.1.4-.2.3-.1 0-.1-.3 0-.4l.7-3.9s.1-.3.2-.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000016062935112785127350000010176851095412318140_",
    x1: 9.009,
    x2: 16.74,
    y1: 3.978,
    y2: -5.235,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000016062935112785127350000010176851095412318140_)"
    },
    d: "M12 16c-.1.2-.2.3-.3.3s.1-.3.1-.3l2.3-5.7c.1-.2.3-.3.4-.3s0 .4-.1.5c-1.3 3.2-1.7 4.1-2.4 5.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000002382845068180201700000013715084230610696095_",
    x1: 9.338,
    x2: 17.042,
    y1: 4.255,
    y2: -4.927,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000002382845068180201700000013715084230610696095_)"
    },
    d: "M12.5 15.7c.1 0 .2-.1.3-.3l4.3-7.1c.1-.1.1-.3 0-.4s-.3.1-.4.3l-4 7.2c-.1.1-.2.3-.2.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000158751717828373549920000015029838481486377900_",
    x1: 10.102,
    x2: 17.784,
    y1: 4.902,
    y2: -4.252,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000158751717828373549920000015029838481486377900_)"
    },
    d: "M12.7 16.5c-.1-.1 0-.3.2-.4l4.6-6.6c0-.3.3-.5.5-.4s.2.3 0 .4l-5 6.6c-.1.3-.3.4-.3.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000041286984743335244670000013878791327349144967_",
    x1: 11.148,
    x2: 18.806,
    y1: 5.781,
    y2: -3.345,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000041286984743335244670000013878791327349144967_)"
    },
    d: "m14 15.7-.3.3c-.1-.1.1-.2.2-.3l.2-.2 6.4-7.3c.1-.1.3-.2.3 0l.2.3c.1.1.1.3 0 .4l-7 6.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000138574384922886777890000008416176582122737590_",
    x1: 11.83,
    x2: 19.463,
    y1: 6.357,
    y2: -2.739,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000138574384922886777890000008416176582122737590_)"
    },
    d: "M13.5 16.9c-.1-.1.1-.2.3-.3l6.8-6.3c.1-.1.3-.1.4 0 .2.2.2.3.2.3 0 .2-.1.3-.2.4l-7.1 5.6c-.2.3-.4.4-.4.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000114058897051023468730000011920916283472254647_",
    x1: 12.919,
    x2: 20.526,
    y1: 7.274,
    y2: -1.791,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000114058897051023468730000011920916283472254647_)"
    },
    d: "m14.9 16.4 7.9-5.7c.2-.1.3-.1.3.1l.2.6c0 .2-.1.3-.3.5l-8 4.7c-.2.1-.4.3-.4.2-.1-.2.1-.3.3-.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000083057728449024883820000001319308895808149417_",
    x1: 13.349,
    x2: 20.917,
    y1: 7.626,
    y2: -1.393,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000083057728449024883820000001319308895808149417_)"
    },
    d: "M14.1 17.5c0-.1.2-.2.4-.3l7.1-3.5c.2-.1.3-.1.3.1v.8c0 .2-.2.3-.4.4l-7 2.4c-.2.2-.4.2-.4.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000061474021997726412860000002346556990154899368_",
    x1: 14.396,
    x2: 21.914,
    y1: 8.5,
    y2: -0.46,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000061474021997726412860000002346556990154899368_)"
    },
    d: "m22.3 16.9-6.8.9c-.3 0-.4.1-.5 0 0-.1.2-.2.4-.3l7.1-2.2c.3-.1.4 0 .3.2l-.1.8c.1.3-.1.5-.4.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000112606908929014573360000018093776220234419092_",
    x1: 14.502,
    x2: 21.958,
    y1: 8.579,
    y2: -0.308,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000112606908929014573360000018093776220234419092_)"
    },
    d: "M14.6 18.5c0-.1.3-.2.6-.2l6-.7c.3 0 .5.1.4.3l-.1.3c-.1.2-.3.3-.6.3h-5.8c-.3.1-.5.1-.5 0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "suntrust_svg__SVGID_00000091699600777484351900000013051017003943300516_",
    x1: 8.443,
    x2: 16.201,
    y1: 3.502,
    y2: -5.745,
    gradientTransform: "translate(0 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#f5a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#e98f07"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    style: {
      stopColor: "#dc740e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#d46413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#d15e14"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#suntrust_svg__SVGID_00000091699600777484351900000013051017003943300516_)"
    },
    d: "M13.7 9.6s-1.7 5.3-1.8 5.7c-.1.3-.2.6-.3.6s0-.2.1-.4l1.6-5.9c.1-.3.3-.4.4-.4.2-.2.1.2 0 .4"
  })));
};
export default SvgSuntrust;